import { getField, updateField } from 'vuex-map-fields'
import api from '../api'

export const state = {
	email: '',
	loading: false,
	contactDetails: {
		company_address: '',
		company_number: ''
	}
}

export const mutations = {
	updateField,

	uploadProgress () {
	}
}

export const actions = {
	async requestDemo ({ state, dispatch, commit }, payload) {
		state.loading = true

		const { error, status } = await api('post', `/insight/landing-page/request-email`, payload)

		state.email = ''
		if (status) {
			commit('TOGGLE_BANNER', {
				status: true,
				message: 'success_demo_request',
				type: 'success'
			}, { root: true })

			state.loading = false
			return
		}

		commit('TOGGLE_BANNER', {
			status: true,
			message: error ? error.email[0] : 'error_something_wrong',
			type: 'warning'
		}, { root: true })
		state.loading = false

		// if (data.status !== 200) {
		// 	state.loading = false

		// 	if (
		// 		data.status === 422 &&
		// 		data.errors &&
		// 		data.errors.email
		// 	) {
		// 		commit('TOGGLE_BANNER', {
		// 			status: true,
		// 			message: data.errors.email[0],
		// 			type: 'warning'
		// 		}, { root: true })

		// 		return
		// 	}

		// 	commit('TOGGLE_BANNER', {
		// 		status: true,
		// 		message: 'Sorry, Something went wrong.',
		// 		type: 'failed'
		// 	}, { root: true })
		// 	return
		// }

		// commit('TOGGLE_BANNER', {
		// 	status: true,
		// 	message: 'Successfully requested a demo.',
		// 	type: 'success'
		// }, { root: true })

		// state.loading = false
	},

	async downloadPDF ({ state, dispatch }) {
		state.loading = true

		const { data, status } = await api('post', `/insight/landing-page/download-upmood-mass`, {}, true)

		if (status && data.type !== 'text/html' && data.type !== 'application/json') {
			state.loading = false
			return { isSuccess: true, data }
		}

		state.loading = false
		return { isSuccess: false }
	},

	async getContactDetails ({ state, dispatch }) {
		state.loading = true

		const { data } = await api('get', `/universal/company-details`)
		state.contactDetails = data.data
	    state.loading = false
	}
}

const getters = {
	getField
}

export default {
	state,
	actions,
	mutations,
	getters,
	namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/landing-page/app.js